<template>
    <div class="loading-indicator">
        <span class="ellipsis-anim">
            <span></span>
            <span></span>
            <span></span>
        </span> 
    </div>
</template>

<script>
export default {
    name: 'LoadingIndicator',
}
</script>

<style lang="scss">
.loading-indicator {
    margin: auto;
    color: inherit;
}

.ellipsis-anim {
    display: flex;
    margin: auto;
    justify-content: space-between;
    align-items: center;
    width: 40px;
    height: 3rem;

    span {
        opacity: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: currentColor;
        animation: ellipsis-dot 1s infinite;

        &:nth-child(1) {
            animation-delay: 0.0s;
        }
        &:nth-child(2) {
            animation-delay: 0.1s;
        }
        &:nth-child(3) {
            animation-delay: 0.2s;
        }
    }
}

@keyframes ellipsis-dot {
    0% { 
        opacity: 0;
        transform: scale(0.5); 
    }
    50% { 
        opacity: 1;
        transform: scale(1);
    }
    100% { 
        opacity: 0;
        transform: scale(0.5); 
    }
}
</style>
